import { http } from 'http/index'
import {
  confirmSignIn,
  fetchAuthSession,
  fetchUserAttributes,
  getCurrentUser,
  signIn,
  signOut,
  updatePassword
} from 'aws-amplify/auth'

import UserService from './user.service'
import { BROADCAST_CHANNEL } from 'services/broadcast'

import { BROADCAST_CHANNEL_TYPES } from 'services/broadcast/type.d'
class AuthService {
  private async buildLegacyCognitoUser(): Promise<any> {
    const [session, attributes, currentUser] = await Promise.all([
      fetchAuthSession(),
      fetchUserAttributes().catch((): any => ({})),
      getCurrentUser().catch((): any => null)
    ])
    const tokens: any = session?.tokens

    return {
      username: currentUser?.username,
      attributes,
      signInUserSession: {
        accessToken: {
          jwtToken: tokens?.accessToken?.toString() || ''
        },
        idToken: {
          jwtToken: tokens?.idToken?.toString() || ''
        },
        refreshToken: {
          token: tokens?.refreshToken?.toString?.() || ''
        }
      }
    }
  }

  async login(username: string, password: string): Promise<any> {
    const response: any = await signIn({ username, password })

    if (
      response?.nextStep?.signInStep ===
      'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED'
    ) {
      const challengeResponse: any = {
        challengeName: 'NEW_PASSWORD_REQUIRED',
        username
      }
      UserService.setCurrentUser(challengeResponse)
      return challengeResponse
    }

    const user: any = await this.buildLegacyCognitoUser()
    UserService.setCurrentUser(user)
    return user
  }

  logoutAzure(): void {
    signOut().catch((): void => {})
    UserService.removeCurrentUser()
    UserService.removeListNonAccess()
    UserService.removeListCountry()
    UserService.removePrevious()
    if (
      window.self === window.top &&
      process.env.REACT_APP_IS_LOGIN_COGNITO !== 'true'
    ) {
      // &response_type=${
      //   process.env.REACT_APP_RESPONSE_TYPE_LOGOUT
      // }&scope=aws.cognito.signin.user.admin+email+openid+phone+profile
      window.location.href = `${
        process.env.REACT_APP_URL_DOMAIN_COGNITO_LOGOUT
      }?client_id=${process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID}
      &redirect_uri=${encodeURIComponent(
        `${process.env.REACT_APP_REDIRECT_URL}`
      )}&logout_uri=${encodeURIComponent(
        `${process.env.REACT_APP_REDIRECT_URL}logout`
      )}`
    }
  }

  logout(): void {
    signOut().catch((): void => {})
    UserService.removeCurrentUser()
    UserService.removeListNonAccess()
    UserService.removeListCountry()
    UserService.removePrevious()
  }

  logoutAllTabs(): void {
    BROADCAST_CHANNEL.postMessage({
      type: BROADCAST_CHANNEL_TYPES.SIGN_OUT
    })
    this.logoutAzure()
  }

  register(username: string, email: string, password: string): Promise<any> {
    return http.post('/signup', {
      username,
      email,
      password
    })
  }

  completePassword(user: any, newPassword: string): Promise<any> {
    return confirmSignIn({
      challengeResponse: newPassword,
      options: {
        userAttributes: {
          name: 'UserName',
          phone_number: '+1234567890'
        }
      }
    })
  }

  changePassword(oldPassword: string, newPassword: string): Promise<any> {
    return updatePassword({
      oldPassword,
      newPassword
    })
  }
}
// eslint-disable-next-line
export default new AuthService()
